import { z } from 'zod';
export const NielsenPeriodStrSchema = z.templateLiteral([z.number(), 'P', z.string()]);
//# sourceMappingURL=nielsen.type.js.map